export default __webpack_public_path__ + "static/card-visa-debit-342b5ca9e9c4b22511ce4a8a67b5e037.png";